import React from 'react';
import styled, { css } from 'styled-components';
import { Link as MuiLink } from '@ally/metronome-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
const getEmberRoute = (to) => {
    const split = to.split('/');
    return split.reduce((acc, segment) => {
        if (acc && segment) {
            return `${acc}.${segment}`;
        }
        return segment || acc;
    }, '');
};
const StyledMuiLink = styled(MuiLink)(({ theme: { fontSizes, fonts, fontWeights } }) => css `
    font-size: ${fontSizes.md};
    font-family: ${fonts.regular};
    font-weight: ${fontWeights.bold};
    a {
      font-size: ${fontSizes.md};
      font-family: ${fonts.regular};
      font-weight: ${fontWeights.bold};
    }
  `);
export default function MenuLink({ to, text, routeInEmber, accordionName, closeMenu, withAllyTM, }) {
    const isRelativeRoute = /^\//.test(to);
    const emberRoute = routeInEmber && isRelativeRoute ? getEmberRoute(to) : '';
    const dataTrackName = accordionName
        ? `${accordionName} - ${text}`
        : `profile-panel - ${text}`;
    const useAnchorTag = /^mailto:/.test(to);
    const useEmberRouting = routeInEmber && !!emberRoute;
    if (useAnchorTag)
        return (React.createElement(StyledMuiLink, { variant: "link", text: text, allytmln: withAllyTM !== null && withAllyTM !== void 0 ? withAllyTM : dataTrackName, href: to }));
    if (!useEmberRouting) {
        return (React.createElement(StyledMuiLink, { variant: "link", text: text, allytmln: withAllyTM !== null && withAllyTM !== void 0 ? withAllyTM : dataTrackName },
            React.createElement(ReactRouterLink, { to: to })));
    }
    return (React.createElement(StyledMuiLink, { href: to, variant: "link", text: text, allytmln: withAllyTM !== null && withAllyTM !== void 0 ? withAllyTM : dataTrackName, onClick: (e) => {
            e.preventDefault();
            closeMenu(e);
            routeInEmber(emberRoute, to);
        } }));
}
//# sourceMappingURL=MenuLink.js.map